import { providerRequestsTyped } from "@/api/(requests)/providerTyped";
import type { UUID, UpdateProviderBody } from "@/core/types";

export async function updateProviderProfile({
  body,
  providerId,
}: {
  body: UpdateProviderBody;
  providerId?: UUID;
}): Promise<void> {
  return providerRequestsTyped.update_profile({
    body,
    searchParams: { provider_id: providerId },
  });
}
